import { getStylesFn } from 'core/helpers/styles'
import { ElementIconOptions } from 'core/types/element/element_icon'
import optionsPropTypes from 'PropsSpec'
import IconElement from './common/Icon'

const extractStyles = getStylesFn(
  ['backgroundColor', 'marginTop', 'paddingTop', 'paddingRight', 'paddingBottom', 'paddingLeft'],
  {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }
)

type Props = {
  options: ElementIconOptions
}

const Icon = ({ options }: Props) => {
  const { icon } = options
  const styles = {
    ...extractStyles(options),
    color: `rgba(${options.color})`,
    fontSize: options.size
  }

  return <IconElement className="wf_reset" code={icon.code} styles={styles} />
}

Icon.propTypes = {
  options: optionsPropTypes('icon')
}

export default Icon
